module.exports = __webpack_public_path__ + "media/AI_welcome.90ff5d7f.mp3";